module.exports = __webpack_public_path__ + "img/system49-mini.68b2af48.png";